export const shouldSyncScriptTextFromInitialText = ({
  currentText,
  originText,
}: {
  currentText: string;
  originText: string;
}) => {
  return currentText === originText;
};
